<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-folder`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M2 8a2 2 0 012-2h16a2 2 0 012 2v2h21.905c1.157 0 2.095.895 2.095 2v28c0 1.105-.938 2-2.095 2H4.095C2.938 42 2 41.105 2 40V8zm40 6H6v24h36V14z"/></svg>
</template>
<script>

export default {
  name: 'IconFolder',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
